import * as z from 'zod'
import { zodRequiredField } from '@/shared/config/zod/schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { fieldNames } from '@/shared/constants/field-names'

export const dto = z.object({
  [fieldNames.HYPOTHESES_FILTER_GROWTH_POINT]: z.record(z.string(), zodRequiredField()).array(),
  [fieldNames.HYPOTHESES_FILTER_ACHIVEMENT_STATUS]: z.record(z.string(), zodRequiredField()).array(),
  [fieldNames.HYPOTHESES_FILTER_KIND]: z.record(z.string(), zodRequiredField()).array(),
  [fieldNames.HYPOTHESES_FILTER_MARK_TYPE]: z.record(z.string(), zodRequiredField()).array(),
  [fieldNames.HYPOTHESES_FILTER_PRIORITY]: zodRequiredField().array(),
  [fieldNames.HYPOTHESES_FILTER_PROCESS_STATUS]: z.record(z.string(), zodRequiredField()).array(),
  [fieldNames.HYPOTHESES_FILTER_STATUS]: zodRequiredField().array(),
  [fieldNames.HYPOTHESES_FILTER_TOOL]: zodRequiredField().array(),
  [fieldNames.HYPOTHESES_FILTER_MARK]: zodRequiredField().array(),
})

export default zodResolver(dto)
